export const fetch = {
  pathname: id => `/api/v4/actor/${id}`,
}

export const fetchActorCampaigns = {
  pathname: id => `/api/v4/actor/${id}/campaigns`
}

export const fetchActorReports = {
  pathname: id => `/api/v4/actor/${id}/reports`,
}

export const fetchReportsVocab = {
  pathname: () => '/reports/vocabulary',
}

export const fetchActorHistory = {
  pathname: id => `/api/v4/actor/${id}/history`,
}

export const fetchActors = {
  pathname: '/api/v4/actor',
  search: ({ search }) => search,
}

export const fetchActorsMalware = {
  pathname: '/api/v4/actor/malware',
  method: 'POST',
  headers: {
    'content-type': 'application/json'
  },
  body: (payload) => JSON.stringify(payload)
}

export const fetchActorMtt = {
  pathname: '/api/v4/actor/mtt',
  method: 'POST',
  headers: {
    'content-type': 'application/json'
  },
  body: (payload) => JSON.stringify(payload)
}

export const fetchActorTtp = {
  pathname: '/api/v4/actor/ttp',
  method: 'POST',
  headers: {
    'content-type': 'application/json'
  },
  body: (payload) => JSON.stringify(payload)
}

export const fetchActorVocab = {
  pathname: '/api/v4/actor/vocab',
}
